import { TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/design-system/tooltip';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

export const TooltipWrapper = ({
  trigger,
  content,
  className,
  delayDuration,
  side = 'top',
  sideOffset,
  disableHoverableContent
}: {
  trigger: React.ReactNode;
  content: React.ReactNode;
  className?: string;
  delayDuration?: number;
  side?: 'top' | 'right' | 'bottom' | 'left';
  sideOffset?: number;
  disableHoverableContent?: boolean;
}) => {
  return (
    <TooltipProvider delayDuration={delayDuration} disableHoverableContent={disableHoverableContent}>
      <TooltipPrimitive.Root>
        <TooltipTrigger asChild>{trigger}</TooltipTrigger>
        <TooltipContent side={side} sideOffset={sideOffset} className={className}>
          {content}
        </TooltipContent>
      </TooltipPrimitive.Root>
    </TooltipProvider>
  );
};
